<!-- PROCESO MANUAL -->
<tec-pwcs-layout
    [ngClass]="{
        'pwcs-style-old': operation.config?.iframe,
        dark: designService.isDarkMode(),
        'hide-subtitle': !(pageWarning.show || handsetLandscape),
        'take-photo': !capturedImage && !(pageWarning.show || handsetLandscape)
    }"
    [title]="pageWarning.type === PAGE_WARNING.HELP ? (helpTitle | translate) : ''"
    [subtitle]="!handsetLandscape ? subtitle : ''"
    [footerLabel]="
        operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape
            ? ('GENERAL.TUTORIAL_ENCRYPTION' | translate)
            : ''
    "
>
    <ng-container content>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) {
            <tec-tile
                type="status"
                [title]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_DESCRIPTION' | translate"
                icon="icon-alert"
            >
                <tec-link
                    [label]="'LIFE_CHECK.HELP.TITLE' | translate"
                    (click)="isVisibleHelpNoPermissionsCamera = true"
                ></tec-link>
            </tec-tile>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- MAIN -->
            <div
                class="content__identity"
                [ngStyle]="{ display: pageWarning.show || handsetLandscape ? 'none' : 'contents' }"
            >
                @if (loading.show) {
                    <tec-spinner
                        [show]="loading.show"
                        [opaque]="true"
                        [text]="loading.text"
                        [img]="designService.getCustomSpinnerUrl() || undefined"
                    ></tec-spinner>
                }

                <div class="video" [class.video--drive-license]="doc?.type === DOCS_TYPE.DRIVE_LICENSE">
                    <app-video
                        [ngClass]="{ 'video-hidden': capturedImage }"
                        [constraints]="ocrService.constraints"
                        [forceFlipHorizontal]="forceFlipHorizontal"
                        [enableTapToFocus]="!capturedImage && !loading.show"
                        (cameraError)="onCameraError($event)"
                        (cameraPermissionRevoked)="onCameraPermissionRevoked()"
                        (cameraStarted)="onCameraStarted($event)"
                        (cameraSwitchStarted)="onCameraSwitchStarted()"
                        (cameraSwitchCompleted)="onCameraSwitchCompleted()"
                    ></app-video>

                    <!-- Imagen capturada superpuesta -->
                    @if (capturedImage) {
                        <img [src]="capturedImage" />
                    }
                </div>

                @if (!loading.show) {
                    <span class="content__identity__subtitle-mobile" [innerHTML]="subtitle"></span>
                }

                <!-- BOTON CAMBIO CAMARA -->
                @if (operation?.config?.iframe && allCameras && allCameras.length > 1) {
                    <div class="change-camera">
                        <span>{{ 'GENERAL.BUTTON.CHANGE_CAMERA' | translate }}</span>
                        <tec-button-icon
                            icon="icon-refresh"
                            type="circle"
                            size="lg"
                            (clickEvent)="changeCamera()"
                        ></tec-button-icon>
                    </div>
                }

                <!-- QR -->
                @if (operation?.config?.iframe && !loading.show) {
                    <div [ngClass]="{ widget: true, open: openQR }">
                        <div class="widget__intro">
                            <h6>{{ 'GENERAL.QR.TITLE' | translate }}</h6>
                            <span>{{ 'GENERAL.QR.DESCRIPTION' | translate }}</span>
                        </div>
                        <div class="widget__content">
                            <div class="widget__content__qr" id="qrcode2" [title]="auth.getQRUrl()">
                                <tec-qr [url]="auth.getQRUrl()" />
                            </div>
                            <p class="widget__content__url">{{ auth.getQRUrl() }}</p>
                        </div>
                        <button class="button button-icon" (click)="openQR = !openQR">
                            <i class="icon-chevron-down"></i>
                        </button>
                    </div>
                }
            </div>

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    <div class="tile tile--help">
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="
                                    'assets/images/id-blurred' + (designService.isDarkMode() ? '-dark' : '') + '.svg'
                                "
                                idSuffix="docs-take-photo-help-id-blurred"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_1' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-bright' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="docs-take-photo-help-id-bright"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-cut' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="docs-take-photo-help-id-cut"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="'assets/images/id-finger' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                idSuffix="docs-take-photo-help-id-finger"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_6' | translate }}</span>
                            </p>
                        </div>
                    </div>
                    <tec-alert
                        [msg]="'OCR.BACK.MODAL_HELP.TIP_5' | translate"
                        type="message"
                        hiddenCloseButton
                        icon="icon-info"
                    ></tec-alert>
                }
                @if (pageWarning.type === PAGE_WARNING.VERIFICATION_FAIL) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.DESCRIPTION' | translate"
                        icon="icon-alert"
                    >
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert"
                    >
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert"
                    >
                    </tec-tile>
                }
            }

            <!-- HANDSETLANDSCAPE -->
            @if (handsetLandscape && !pageWarning.show) {
                <app-handset-landscape-tile />
            }
        }
    </ng-container>

    <!-- ACCIONES -->
    <ng-container actions>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) {
            <tec-button type="secondary" [size]="'lg'" (clickEvent)="isVisibleChangeDevice = true">
                {{ 'GENERAL.BUTTON.OTHER_DEVICE' | translate }}
            </tec-button>
            <tec-button [size]="'lg'" (clickEvent)="checkPermissions()">
                {{ 'GENERAL.BUTTON.PERMISSIONS_ACTIVATED' | translate }}
            </tec-button>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    <!-- DESDE SEGUNDO INTENTO -->
                    <tec-button
                        [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                        [size]="'lg'"
                        (clickEvent)="setPageWarning(null, false)"
                    ></tec-button>
                }
            }

            <!-- Botón para tomar foto -->
            @if (!operation?.config?.tutorial && !pageWarning.show && !handsetLandscape) {
                @if (!capturedImage) {
                    <tec-button-icon
                        [type]="'circle'"
                        [icon]="'icon-camera'"
                        [size]="'lg'"
                        (clickEvent)="takePhoto()"
                    ></tec-button-icon>
                }
                @if (capturedImage) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.REPEAT' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="repeatPhoto()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.SAVE' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="sendPhoto()"
                    ></tec-button>
                }
            }
        }
    </ng-container>

    <!-- NAV HELP -->
    @if (
        !operation?.config?.iframe &&
        permissionsCamera &&
        !pageWarning.show &&
        !handsetLandscape &&
        !capturedImage
    ) {
        <tec-nav-help
            [elements]="operation?.config?.tutorial ? navsHelpTutorial : navsHelp"
            (clickEvent)="navHelpChange($event)"
        ></tec-nav-help>
    }

    <!-- WATERMARK -->
    @if ((designService.configDesign$ | async)?.showWatermark && !operation?.config?.iframe) {
        <tec-watermark type="default"></tec-watermark>
    }
</tec-pwcs-layout>

<app-modal-scan-qr
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
/>
